"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var each_1 = require("./each");
var is_object_1 = require("./is-object");
//#endregion
function mapValues(obj, transformer) {
    if (!is_object_1.default(obj))
        return obj;
    var result = {};
    each_1.default(obj, function (value, key) {
        result[key] = transformer(value, key, obj);
    });
    return result;
}
exports.default = mapValues;
//# sourceMappingURL=map-values.js.map